import React from 'react';
import { pcPageConfig } from './pcPageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { shallowEqual, useSelector } from 'umi';
import { IDataFrame, ISelectorState } from '@/pages/dashboard/types/dashboard';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import { casualPageConfig } from '@/pages/dashboard/pages/monetization/ltv/casualPageConfig';
import './index.scss';

const reqParams = '/monetization/ltv';
const Register = () => {
  const dataFrame = useSelector((state: ISelectorState) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  }, shallowEqual);

  const pageMap: Partial<Record<IDataFrame, IPageConfigType>> = {
    casual: casualPageConfig as unknown as IPageConfigType,
    pc: pcPageConfig as unknown as IPageConfigType,
    mobile: pcPageConfig as unknown as IPageConfigType,
  };

  return (
    <>
      <CommonPageRender
        reqParams={reqParams}
        pageConfigInit={pageMap?.[dataFrame]}
      />
    </>
  );
};

export default Register;

